import styled from 'styled-components';
import ArrowDownIcon from '../../../../../Icons/ArrowDownIcon';

export const SpecialRequestLoader = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto;
    width:79.3rem;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
    margin:${props.theme.spacing.xlarge} 0 0 0;
  
  `,
);

export const ArrowDownWrap = styled.div(
  props => `
    display:flex;
    justify-content:center;
    align-items:center;
    background:${props.theme.colors.goBrandBlue.light};
    border-radius:50%;
    height:2.6rem;
    width:2.6rem;
  `,
);

export const ArrowDown = styled(ArrowDownIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill:${props.theme.colors.downriver.medium};
    `,
);

export const HeaderWithIconWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content: space-between;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.custom(30)};
  `,
);

export const SpecialRequestHeader = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:3.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const SpecialRequestDescriptionWrap = styled.div(
  props => `
    padding:${props.theme.spacing.base} ${props.theme.spacing.custom(30)} ${
    props.theme.spacing.xlarge
  };
  `,
);

export const SpecialRequestTitle = styled.div(
  props => `
    display:flex;
    width:7.5rem;
    height:2.1rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.base} 0 ;
  
  `,
);

export const SpecialRequestSubTitle = styled.div(
  props => `
    display:flex;
    width:33.7rem;
    height:3.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.base} 0 ;

`,
);

export const SpecialRequestTextarea = styled.textarea(
  props => `
    display:flex;
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    width:64.3rem;
    height:10rem;
    border-radius: ${props.theme.misc.borderRadius.base};

    &::placeholder {
        color: ${props.theme.colors.downriver.medium};  
        font-size: ${props.theme.font.custom(14)};
        padding: ${props.theme.spacing.base};
        font-weight:400;
      }


`,
);
